import React, { useState } from 'react'
import {
  Container,
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton
} from '@mui/material'
import {
  Settings,
  Security,
  Notifications,
  Storage,
  Edit,
  Save
} from '@mui/icons-material'

export const SettingsPage = () => {
  const [tabValue, setTabValue] = useState(0)
  const [settings, setSettings] = useState({
    systemName: 'MRD System',
    hospitalName: 'General Hospital',
    emailNotifications: true,
    autoBackup: true,
    sessionTimeout: 30,
    maxFileSize: 10
  })

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }))
  }

  const handleSave = () => {
    console.log('Save settings:', settings)
  }

  return (
    <Container maxWidth="xl">
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={600} gutterBottom>
          System Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configure system preferences and security settings
        </Typography>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)}>
          <Tab 
            label="General" 
            icon={<Settings />}
            iconPosition="start"
          />
          <Tab 
            label="Security" 
            icon={<Security />}
            iconPosition="start"
          />
          <Tab 
            label="Notifications" 
            icon={<Notifications />}
            iconPosition="start"
          />
          <Tab 
            label="Storage" 
            icon={<Storage />}
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {/* General Settings */}
      {tabValue === 0 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardHeader title="System Information" />
              <CardContent>
                <TextField
                  fullWidth
                  label="System Name"
                  value={settings.systemName}
                  onChange={(e) => handleSettingChange('systemName', e.target.value)}
                  sx={{ mb: 3 }}
                />
                <TextField
                  fullWidth
                  label="Hospital Name"
                  value={settings.hospitalName}
                  onChange={(e) => handleSettingChange('hospitalName', e.target.value)}
                  sx={{ mb: 3 }}
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Session Timeout (minutes)"
                  value={settings.sessionTimeout}
                  onChange={(e) => handleSettingChange('sessionTimeout', parseInt(e.target.value))}
                />
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card>
              <CardHeader title="System Preferences" />
              <CardContent>
                <FormControlLabel
                  control={
                    <Switch
                      checked={settings.emailNotifications}
                      onChange={(e) => handleSettingChange('emailNotifications', e.target.checked)}
                    />
                  }
                  label="Email Notifications"
                />
                <br />
                <FormControlLabel
                  control={
                    <Switch
                      checked={settings.autoBackup}
                      onChange={(e) => handleSettingChange('autoBackup', e.target.checked)}
                    />
                  }
                  label="Automatic Backup"
                />
                <Divider sx={{ my: 2 }} />
                <TextField
                  fullWidth
                  type="number"
                  label="Max File Size (MB)"
                  value={settings.maxFileSize}
                  onChange={(e) => handleSettingChange('maxFileSize', parseInt(e.target.value))}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Security Settings */}
      {tabValue === 1 && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title="Security Configuration" />
              <CardContent>
                <Typography variant="body1" color="text.secondary" textAlign="center" py={4}>
                  Security settings will be implemented here
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Notification Settings */}
      {tabValue === 2 && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title="Notification Preferences" />
              <CardContent>
                <Typography variant="body1" color="text.secondary" textAlign="center" py={4}>
                  Notification settings will be implemented here
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Storage Settings */}
      {tabValue === 3 && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title="Storage Configuration" />
              <CardContent>
                <Typography variant="body1" color="text.secondary" textAlign="center" py={4}>
                  Storage settings will be implemented here
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Save Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          variant="contained"
          startIcon={<Save />}
          onClick={handleSave}
        >
          Save Settings
        </Button>
      </Box>
    </Container>
  )
}

export default SettingsPage